import { z } from "zod"

export interface LeasingCompany {
  id: string
  name: string
  logo?: string | null
}

export const SaveLeasingCompanySchema = z.object({
  name: z.string().min(1),
})

export type SaveLeasingCompany = z.infer<typeof SaveLeasingCompanySchema>
